import React from "react";

const DetailsSection: React.FC = () => {
  return (
    <section className="bg-[#FFFF] pb-10 md:pb-12">
      <div className="w-full max-w-[1200px] mx-auto lg:px-6">
        <article className="w-full lg:w-[83.17%] mx-auto lg:rounded-b-[16px] rounded-none bg-[#EDF1F9] p-5 md:pt-10 md:pb-10 md:px-24 text-[#1f2d3d] font-[500] text-[17px] md:text-[14px] leading-[1.6]">
          <p>
            On November 17, 2025, Rob spotlighted{" "}
            <strong>Gold X2 Mining </strong>(TSXV: AUXX; OTCQB: GSHRF) as his
            NEW PICK!
          </p>
          <p>In his detailed recommendation, Rob highlighted:</p>
          <ul className="list-disc pl-10 mt-3 space-y-1">
            <li>
              A robust resource estimate exceeding{" "}
              <strong>6 million ounces of gold</strong> at the Moss project.
            </li>
            <li>
              At least half open-pittable in a prime location near Thunder Bay,
              Ontario—a Tier-1 mining jurisdiction with excellent
              infrastructure.
            </li>
            <li>
              All the hallmarks of a future mine: scale, location, and
              attractiveness to major producers for potential acquisition and
              development.
            </li>
            <li>
              The stock in a solid uptrend, with a major near-term catalyst: a{" "}
              <strong>mineral resource update</strong> plus the release of a{" "}
              <strong>Preliminary Economic Assessment (PEA)</strong> prepared by
              G Mining (expected mid-December 2025).
            </li>
            <li>
              Rob's conviction: "I am a buyer for my portfolio in advance of the
              PEA results, as I think this will show the potential for{" "}
              <strong>275 koz gold production</strong> from an excellent
              jurisdiction."
            </li>
          </ul>

          <p className="mt-4">
            He backed it up with an <strong>excellent, detailed video</strong>{" "}
            walking through the thesis, project details, and why it stood out as
            a high-conviction opportunity.
          </p>

          <p className="mt-3">
            <strong>Fast-forward to February 4, 2026:</strong>
          </p>
          <p>
            Subscribers who followed Rob's recommendation and bought shares
            around the 51-cent level have seen the stock surge to a high of{" "}
            <strong>$1.44 CAD</strong>—and it's currently trading around{" "}
            <strong>$1.10 CAD</strong> (with recent trading in the{" "}
            <strong>$1.07–$1.18 range</strong> amid strong volume and positive
            momentum).
          </p>
          <p>
            That's a <strong>gain of over 100% </strong>(more than doubling) in
            under three months, even after the PEA delivery on January 26, 2026,
            which confirmed strong economics:
          </p>
          <ul className="list-disc pl-10 mt-2 space-y-1">
            <li>
              Updated resource with significant indicated growth (73% increase
              in indicated ounces).
            </li>
            <li>
              PEA outlining potential for ~265,000 oz average annual gold
              production over 13+ years, robust NPV/IRR figures, and positioning
              as a potential top-10 Canadian gold mine.
            </li>
          </ul>

          <p className="mt-4">
            This isn't luck—it's the kind of asymmetric upside Rob consistently
            identifies through rigorous due diligence on juniors with real
            catalysts, strong assets, and takeover appeal.
          </p>

          <hr className="my-5 border-0 h-[3px] bg-[#FFFF]" />

          <h1 className="text-[25px] md:text-[30px] lg:text-[30px] font-[800] leading-[30px] text-[#1f2d3d] mb-5 lg:text-left text-center">
            Why Join The Wealthy Miner Today?
          </h1>
          <ul className="list-disc pl-10 mt-2 space-y-1 mb-5">
            <li>
              <strong>Get Rob's Picks First:</strong> Early access to
              high-conviction recommendations like Gold X2—before they run.
            </li>
            <li>
              <strong>In-Depth Analysis + Video Insights:</strong> Detailed
              write-ups, charts, and Rob's signature video breakdowns to
              understand the "why" behind every pick.
            </li>
            <li>
              <strong>Proven Track Record:</strong> Real wins like this one
              demonstrate the value of following an experienced voice in a
              volatile sector.
            </li>
            <li>
              <strong>Community & Ongoing Updates:</strong> Stay informed on
              portfolio moves, market commentary, and follow-up catalysts from
              Rob himself.
            </li>
          </ul>
          <p>Don't miss the next big opportunity in gold juniors—gold prices are elevated, majors are hunting acquisitions, and the right picks can deliver life-changing returns.</p>
          <p>
          <strong>Subscribe Now to The Wealthy Miner</strong> and gain immediate access to Rob's expertise, current portfolio, and upcoming ideas.
          </p>
          <div className="mt-5">
            <a
              href="https://the-wealthy-miner.mn.co/"
              target="_blank"
              rel="noopener noreferrer"
              className="block w-full rounded-md bg-[#0B6054] hover:bg-[#0f8d72] text-white font-[700] text-[22px] md:text-[30px] leading-none py-3 md:py-4 transition-colors text-center"
            >
              Subscribe Today - Unlock Premium Access
            </a>
            <p className="text-[15px] px-5 text-[#1A2A44] font-[400] mt-2 text-center">
            Questions? Contact us or check our FAQ. Past performance is not indicative of future results. Investing in junior mining stocks involves significant risk—always do your own due diligence.
            </p>

            <div className="mt-6 bg-white rounded-[5px] shadow-[0px_4px_4px_0px_#00000040] p-6 overflow-hidden">
              <img
                src="/images/goldx2mining.webp"
                alt="Gold2X Mining"
                className="w-full h-auto rounded-sm"
              />
            </div>
            <div className="mt-6 bg-white rounded-[5px] shadow-[0px_4px_4px_0px_#00000040] p-6 overflow-hidden">
              <img
                src="/images/goldx2mining2.webp"
                alt="Gold2X Mining"
                className="w-full h-auto rounded-sm"
              />
            </div>
          </div>

        </article>
      </div>
    </section>
  );
};

export default DetailsSection;
